export function deleteRecord(recordId, formName, successMessage) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                formName,
                recordId,
                successMessage,
                type: 'DELETE_RECORD_SUBMIT',
            })
        );
}

export function deleteRecordReset(formName, resetForm = false) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                formName,
                resetForm,
                type: 'DELETE_RECORD_RESET',
            })
        );
}
